/*
userSearch.js
This module handles opening the user search modal, performing the search,
rendering search results, and toggling follow/unfollow on search results.
*/

export function initUserSearch(config) {
    const { isAuthenticated, csrfToken } = config;
  
    // OPEN USER SEARCH MODAL
    const openUserSearchBtn = document.getElementById('openUserSearch');
    const userSearchModal = document.getElementById('userSearchModal');
  
    if (openUserSearchBtn) {
      openUserSearchBtn.addEventListener('click', () => {
        if (!isAuthenticated) {
          $('#authModal').modal('show');
          return;
        }
        $('#userSearchModal').modal('show');
      });
    }
  
    // USER SEARCH FUNCTIONALITY
    const searchUserBtn = document.getElementById('searchUserBtn');
    const searchUserInput = document.getElementById('searchUserInput');
  
    if (searchUserBtn) {
      searchUserBtn.addEventListener('click', async () => {
        await performUserSearch(csrfToken);
      });
    }
  
    if (searchUserInput) {
      // Trigger search on pressing Enter
      searchUserInput.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          await performUserSearch(csrfToken);
        }
      });
    }
  }
  
  async function performUserSearch(csrfToken) {
    const searchResultsDiv = document.getElementById('searchResults');
    const searchUserInput = document.getElementById('searchUserInput');
    if (!searchResultsDiv || !searchUserInput) return;
  
    const query = searchUserInput.value.trim();
    if (!query) {
      searchResultsDiv.innerHTML = `<p class="text-danger">Please enter a username.</p>`;
      return;
    }
    // Normalize the query by stripping "@" if present
    let finalQuery = query.startsWith('@') ? query.slice(1) : query;
  
    // Display searching message
    searchResultsDiv.innerHTML = `<p>Searching...</p>`;
  
    try {
      const response = await fetch(`/search_users?query=${encodeURIComponent(finalQuery)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        searchResultsDiv.innerHTML = `<p class="text-danger">No users found or an error occurred.</p>`;
        return;
      }
      const data = await response.json();
      if (!data || !Array.isArray(data.results) || data.results.length === 0) {
        searchResultsDiv.innerHTML = `<p class="text-muted">No users found for "@${finalQuery}".</p>`;
        return;
      }
      renderUserSearchResults(data.results, searchResultsDiv, csrfToken);
    } catch (err) {
      console.error('Search error:', err);
      searchResultsDiv.innerHTML = `<p class="text-danger">Error searching for users.</p>`;
    }
  }
  
  function renderUserSearchResults(users, containerEl, csrfToken) {
    containerEl.innerHTML = '';
  
    users.forEach((user) => {
      const userItem = document.createElement('div');
      userItem.classList.add('d-flex', 'align-items-center', 'justify-content-between', 'mb-2');
  
      const userInfoDiv = document.createElement('div');
      userInfoDiv.classList.add('d-flex', 'align-items-center');
  
      // Profile Picture
      const img = document.createElement('img');
      img.src = user.profile_picture || '/static/images/default-profile.webp';
      img.alt = user.username;
      img.style.width = '36px';
      img.style.height = '36px';
      img.style.objectFit = 'cover';
      img.style.borderRadius = '50%';
      img.style.marginRight = '0.5rem';
  
      // Username text
      const nameSpan = document.createElement('span');
      nameSpan.textContent = `@${user.username}`;
      nameSpan.style.fontWeight = 'bold';
  
      userInfoDiv.appendChild(img);
      userInfoDiv.appendChild(nameSpan);
  
      // Follow/Unfollow button
      const followBtn = document.createElement('button');
      followBtn.classList.add('btn', 'btn-sm');
      followBtn.setAttribute('data-user-id', user.id);
      followBtn.style.marginLeft = '0.5rem';
  
      if (user.is_following) {
        followBtn.textContent = 'Unfollow';
        followBtn.classList.add('btn-danger');
      } else {
        followBtn.textContent = 'Follow';
        followBtn.classList.add('btn-outline-primary');
      }
  
      // Attach follow/unfollow action
      followBtn.addEventListener('click', async () => {
        await toggleFollowUser(user.id, followBtn, csrfToken);
      });
  
      userItem.appendChild(userInfoDiv);
      userItem.appendChild(followBtn);
      containerEl.appendChild(userItem);
    });
  }
  
  async function toggleFollowUser(userId, buttonEl, csrfToken) {
    // Check if user is authenticated (using feed container data)
    const isAuthenticated = document.getElementById('feed')?.getAttribute('data-current-user-id');
    if (!isAuthenticated) {
      $('#authModal').modal('show');
      return;
    }
  
    const isCurrentlyFollowing = buttonEl.textContent.toLowerCase().includes('unfollow');
    const url = `/account/toggle_follow/${userId}`;
  
    try {
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
      });
      if (!resp.ok) {
        window.showToast('Error following/unfollowing user.', 'danger');
        return;
      }
      const data = await resp.json();
      if (data && data.success) {
        if (isCurrentlyFollowing) {
          buttonEl.textContent = 'Follow';
          buttonEl.classList.remove('btn-danger');
          buttonEl.classList.add('btn-outline-primary');
        } else {
          buttonEl.textContent = 'Unfollow';
          buttonEl.classList.remove('btn-outline-primary');
          buttonEl.classList.add('btn-danger');
        }
        window.showToast(data.message || 'Action completed.', 'success');
      } else {
        window.showToast(data.error || 'Action failed.', 'danger');
      }
    } catch (err) {
      console.error('Error toggling follow:', err);
      window.showToast('Error toggling follow.', 'danger');
    }
  }
  